// Type mapping for API calls - API expects singular types
const typeMapping: Record<string, string> = {
  company: 'counterparty',
  counterparty: 'counterparty',
  product: 'product',
  terminal: 'terminal',
  site: 'site',
  tank: 'tank',
}

// Plural mapping for API endpoints
const _pluralMapping: Record<string, string> = {
  company: 'companies',
  counterparty: 'companies',
  product: 'products',
  terminal: 'terminals',
  site: 'sites',
  tank: 'tanks',
}

/**
 * Get the API type for entity
 */
export const getApiType = (entityType: string): string => {
  return typeMapping[entityType] || entityType
}

/**
 * Get storage key for tenant selection
 */
const getTenantStorageKey = (
  entityType: string,
  side: 'left' | 'right',
): string => {
  return `3way_${side}_tenant_${entityType}`
}

/**
 * Get saved tenant selection from localStorage
 */
export const getSavedTenant = (
  entityType: string,
  side: 'left' | 'right',
): string => {
  return localStorage.getItem(getTenantStorageKey(entityType, side)) || 'none'
}

/**
 * Save tenant selection to localStorage
 */
export const saveTenantSelection = (
  entityType: string,
  side: 'left' | 'right',
  tenant: string,
): void => {
  if (tenant !== 'none') {
    localStorage.setItem(getTenantStorageKey(entityType, side), tenant)
  }
}
